<div class="page-layout blank fullwidth" (scroll)="onScroll()"  style="height: 1px; overflow-y: scroll;    top: 1px;z-index: 99999;">

  <div *ngIf="wishlistCount>0" class="page-layout blank fullwidth">

    <div class="cart mt-8 p-8">
      <div class="top-heading">
        <div style="display: flex;">
          <i (click)="goBack()" class="go-back" style="color: black;font-weight: bold; cursor: pointer;">arrow_back</i>
          <h2 class="cart-title">Request Wish List</h2>
          <div class="saved-label" *ngIf="sparesDiscount>0">SAVED &#8377;{{sparesDiscount | number:'1.2-2'}}</div>
        </div>
        <!-- Share removed -->
      </div>

      <div class="cart-left">
        <div *ngIf="variant1" class="vehicle-details-sec cart-card">
          <div class="make-sec">
            <img
              [src]="'https://cube.getpitstop.com/assets/img/' + make1.toLowerCase().replace(' ', '') + '.png'"
              alt="Make Image"
              class="img-fluid make-image"
            >
          </div>
          <div class="model-sec">
            <p>{{model1}},{{fuelType}}</p>
            <p></p>
            <p>{{variant1}},[{{year1}}]</p>
            <p>{{registrationNumber}}</p>
          </div>
        </div>

        <div *ngIf="vehicleType=='universal' && !make1" class="vehicle-details-sec cart-card">
          <div class="universal-make-sec">
            <mat-icon style="font-size: 35px;">directions_car</mat-icon>
          </div>
          <div class="model-sec universal-sec">Universal</div>
        </div>

        <div class="spares-added-sec cart-card" style="padding-top: 8px;">
          <div class="spares-added-title">
            <div class="spares-count">{{wishlistCount}}</div>
            <h4>Spares Added</h4>
          </div>
          <div class="add-more-sec">
            <button mat-button (click)="addMore()">Add more</button>
          </div>
        </div>

        <div class="spares-added" *ngFor="let item of wishlistList">
          <div class="cart-card mt-8 cart-instock">
            <div class="spares-part">
              <div class="offer-tag-cart" *ngIf="item?.mrp > 0 && item?.sellingPrice > 0 && item?.mrp > item?.sellingPrice">
                {{ ((item?.mrp - item?.sellingPrice) / item?.mrp * 100).toFixed(0) + '%' }} Off
              </div>
              <img *ngIf="item.imageUrl" class="img-fluid part-image" src="{{item.imageUrl}}" alt=""/>
              <img *ngIf="!item.imageUrl" class="img-fluid part-image" src="../../../../assets/images/logos/logo.png" alt="" />
            </div>
            <div class="spare-details-sec">
              <div class="spare-part-name">{{item.name}}</div>
              <div class="spare-brand">{{item.brand?.name}}</div>
              <div class="spare-part-number">{{item.partNumber}}</div>
              <div class="spare-price" *ngIf="item.mrp > item.sellingPrice && item.sellingPrice > 0; else onlyMRP">
                <span class="selling-price">&#8377;{{item.sellingPrice * item.cart_qty | number:'1.2-2'}}</span>
                <span class="mrp-price">&#8377;{{item.mrp * item.cart_qty | number:'1.2-2'}}</span>
                <div class="discount-price">You save &#8377;{{(item.mrp - item.sellingPrice) * item.cart_qty | number:'1.2-2'}}</div>
              </div>
              <ng-template #onlyMRP>
                <div class="spare-price-mrp">
                  &#8377;{{item.mrp * item.cart_qty}}
                </div>
              </ng-template>
            </div>
            <div class="spare-add-cart">
              <div class="btn-group">
                <button mat-raised-button (click)="removeItem(item.cart_qty, item.key)"><mat-icon>remove</mat-icon></button>
                <input type="text" class="part-count" [(ngModel)]="item.cart_qty" readonly>
                <button mat-raised-button (click)="addItem(item.cart_qty, item.key)"><mat-icon>add</mat-icon></button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cart-right">
        <div class="discount-sec" *ngIf="sparesDiscount>0">
          <p>You have saved &#8377;{{sparesDiscount | number:'1.2-2'}} on this request</p>
        </div>

        <div #target class="price-details-sec" [@shakeit]="this.states['shake']" (@shakeit.done)="shakeEnd('shake', $event)">
          <div class="cart-card">
            <div class="price-details-title">Price Details</div>

            <div class="price-details">
              <div class="price-details-left">Spares Total</div>
              <div class="price-details-right">&#8377;{{wishlistSubTotal | number:'1.2-2'}}</div>
            </div>

            <div class="price-details" *ngIf="sparesDiscount>0">
              <div class="price-details-left">Spares Discount</div>
              <div class="price-details-right" id="discount">- &#8377;{{sparesDiscount | number:'1.2-2'}}</div>
            </div>

            <!-- Shipping Charges: mirrors cart's price-details-sec, same two states -->
            <!-- <div class="price-details" *ngIf="(wishlistSubTotal - sparesDiscount) > avoidShippingCharges">
              <div class="price-details-left">Shipping Charges
                <i class="maticon" [attr.data-tooltip]="'Provides free Shipping for orders above ₹ ' + avoidShippingCharges" (click)="openBottomSheet()">
                  info_outline
                </i>
              </div>
              <div class="freetag">₹{{shippingCharges}}
                <span class="price-details-right" style="color: #4caf50;"> FREE</span>
              </div>
            </div>

            <div class="price-details" *ngIf="shippingCharges>0">
              <div class="price-details-left">Shipping Charges
                <i class="maticon" [attr.data-tooltip]="'Provides free Shipping for orders above ₹ ' + avoidShippingCharges" (click)="openBottomSheet()">
                  info_outline
                </i>
              </div>
              <span class="price-details-right">₹{{shippingCharges}}</span>
            </div>

            <ng-template #bottomSheetTemplate>
              <div class="bottom-sheet-content">
                <i class="material-icons" (click)="closeBottomSheet()" style="float: left; cursor: pointer;">cancel</i>
                <h3 style="font-weight: bold;">Shipping Charge</h3>
                <p style="font-size: 13px;">Autoverse provides free Shipping for orders above {{avoidShippingCharges}}</p>
                <button mat-button class="custom-button" (click)="closeBottomSheet()">Okay, Got it</button>
              </div>
            </ng-template> -->

            <div class="price-details" id="total">
              <div class="price-details-left">Total</div>
              <div class="price-details-right">&#8377;{{wishlistGrandTotal | number:'1.2-2'}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="wishlistList.length>0" class="payment-bottom">
      <div class="place-order-sec">
        <div class="grand-total">&#8377;{{wishlistGrandTotal | number:'1.2-2'}}</div>
        <div class="view-details">
          <a (click)="scroll(target)">View Details</a>
        </div>
        <button class="place-order-btn" (click)="createRequest()">Create Request</button>
      </div>
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="wishlistCount==0" class="page-layout blank fullwidth p-12">
    <div class="empty-cart">
      <img src="{{emptyImg}}" alt="" />
      <div class="sec1">No spares added yet</div>
      <div class="sec2">Your car parts are just a click away</div>
      <button mat-button [ngClass]="isMobile ? 'browse-parts-btnMobile' : 'browse-parts-btn'" (click)="browseParts()">Browse Parts</button>
    </div>
  </div>

  <div *ngIf="loading">
    <div #dynamicContainers></div>
  </div>
</div>


<app-asp-request-existspopup
  [isOpen]="isRequestExistsPopupOpen"
  [existingRequest]="existingRequest"
  [vehicleData]="vehicleData"
  [regNo]="regNo"
  (closePopup)="closeRequestExistsPopup()"
  (startFresh)="startFreshRequest()"
  (addToExisting)="addItemsToExistingRequest()">
</app-asp-request-existspopup>

<app-asp-request-success-popup
  [isOpen]="isPopupOpen"
  [isUpdate]="false"
  [requestId]="successRequestId"
  [requestCreatedAt]="successRequestCreatedAt"
  (closePopup)="closeSuccessPopup()"
  (trackRequest)="goToRequestDetails()">
  
</app-asp-request-success-popup>